/**
* @file 协议中心-协议记录
* */
<template>
  <div id="protocolRecord">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-select v-model="query.agreementId" placeholder="选择协议" clearable size="small" style="width:200px"
                 @change="handleSearch">
        <el-option v-for="item in agreementOptions" :key="item.id" :label="item.title" :value="item.id"></el-option>
      </el-select>
      <el-select v-model="query.userType" placeholder="用户类型" clearable size="small" style="width:130px;margin-left:8px"
                 @change="handleSearch">
        <el-option label="乘客" :value="1"></el-option>
        <el-option label="司机" :value="2"></el-option>
        <el-option label="渠道商" :value="3"></el-option>
        <el-option label="管理员" :value="4"></el-option>
      </el-select>
      <el-date-picker v-model="dateRange" type="datetimerange" size="small" range-separator="至"
                      start-placeholder="开始时间" end-placeholder="结束时间" style="margin-left:8px;width:360px"
                      value-format="timestamp" @change="handleSearch">
      </el-date-picker>
      <el-button type="primary" size="small" style="margin-left:8px" @click="handleSearch">查询</el-button>
      <el-button size="small" @click="handleReset">重置</el-button>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" border size="small" v-loading="loading">
      <el-table-column prop="agreementTitle" label="协议名称" min-width="150"></el-table-column>
      <el-table-column label="用户类型" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="getUserTypeTag(scope.row.userType)">{{ getUserTypeLabel(scope.row.userType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="用户名" width="110"></el-table-column>
      <el-table-column prop="userId" label="用户ID" width="100"></el-table-column>
      <el-table-column label="协议版本" width="80" align="center">
        <template slot-scope="scope">v{{ scope.row.agreementVersion || 1 }}</template>
      </el-table-column>
      <el-table-column label="确认时间" width="155">
        <template slot-scope="scope">{{ scope.row.confirmedAt | formatTime }}</template>
      </el-table-column>
      <el-table-column prop="ip" label="IP地址" width="130"></el-table-column>
      <el-table-column label="IP归属地" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.province">{{ scope.row.province }}·{{ scope.row.city }}</span>
          <span v-else-if="scope.row.ipAddress">{{ scope.row.ipAddress }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="设备" width="130">
        <template slot-scope="scope">
          <span v-if="scope.row.deviceBrand">{{ scope.row.deviceBrand }} {{ scope.row.deviceModel }}</span>
          <span v-else-if="scope.row.deviceType">{{ scope.row.deviceType }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="networkType" label="网络" width="80" align="center">
        <template slot-scope="scope">{{ scope.row.networkType || '-' }}</template>
      </el-table-column>
      <el-table-column label="运营商" width="80" align="center">
        <template slot-scope="scope">{{ scope.row.isp || '-' }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="70" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination background layout="total, sizes, prev, pager, next"
                     :total="total" :page-size="query.size" :current-page="query.limit"
                     :page-sizes="[20, 50, 100]"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- 详情 Dialog -->
    <el-dialog title="阅读记录详情" :visible.sync="detailVisible" width="600px" append-to-body>
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="协议名称">{{ detailData.agreementTitle }}</el-descriptions-item>
        <el-descriptions-item label="协议版本">v{{ detailData.agreementVersion || 1 }}</el-descriptions-item>
        <el-descriptions-item label="用户类型">{{ getUserTypeLabel(detailData.userType) }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ detailData.userId }}</el-descriptions-item>
        <el-descriptions-item label="用户名">{{ detailData.userName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="确认时间">{{ detailData.confirmedAt | formatTime }}</el-descriptions-item>
        <el-descriptions-item label="IP地址">{{ detailData.ip || '-' }}</el-descriptions-item>
        <el-descriptions-item label="IP归属地">
          {{ [detailData.country, detailData.province, detailData.city].filter(Boolean).join(' ') || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="运营商">{{ detailData.isp || '-' }}</el-descriptions-item>
        <el-descriptions-item label="网络类型">{{ detailData.networkType || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备品牌">{{ detailData.deviceBrand || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备型号">{{ detailData.deviceModel || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备类型">{{ detailData.deviceType || '-' }}</el-descriptions-item>
        <el-descriptions-item label="操作系统">{{ detailData.os || '-' }}</el-descriptions-item>
        <el-descriptions-item label="浏览器">{{ detailData.browser || '-' }}</el-descriptions-item>
        <el-descriptions-item label="是否代理">{{ detailData.isProxy ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="User-Agent" :span="2">
          <div style="word-break:break-all;font-size:12px;color:#909399">{{ detailData.userAgent || '-' }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "protocolRecord",
  data() {
    return {
      tableData: [],
      total: 0,
      loading: false,
      agreementOptions: [],
      dateRange: null,
      detailVisible: false,
      detailData: {},
      query: {
        agreementId: null,
        userType: null,
        startTime: null,
        endTime: null,
        limit: 1,
        size: 20,
      },
    };
  },
  created() {
    this.loadAgreementOptions();
    this.getList();
  },
  methods: {
    async loadAgreementOptions() {
      const res = await this.$axios.get('/api/v1/manage/protocol/list', { appKey: this.mixinUserInfo.appKey });
      if (res && res.code === 1) this.agreementOptions = res.data || [];
    },
    async getList() {
      this.loading = true;
      const params = { ...this.query, appKey: this.mixinUserInfo.appKey };
      const res = await this.$axios.get('/api/v1/manage/protocol/record/list', params);
      this.loading = false;
      if (res && res.code === 1) {
        this.tableData = res.data || [];
        this.total = res.total || 0;
      }
    },
    handleSearch() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.query.startTime = Math.floor(this.dateRange[0] / 1000);
        this.query.endTime = Math.floor(this.dateRange[1] / 1000);
      } else {
        this.query.startTime = null;
        this.query.endTime = null;
      }
      this.query.limit = 1;
      this.getList();
    },
    handleReset() {
      this.query = { agreementId: null, userType: null, startTime: null, endTime: null, limit: 1, size: 20 };
      this.dateRange = null;
      this.getList();
    },
    handleDetail(row) {
      this.detailData = row;
      this.detailVisible = true;
    },
    handleSizeChange(size) {
      this.query.size = size;
      this.query.limit = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.query.limit = page;
      this.getList();
    },
    getUserTypeLabel(type) {
      return { 1: '乘客', 2: '司机', 3: '渠道商', 4: '管理员' }[type] || '-';
    },
    getUserTypeTag(type) {
      return { 1: '', 2: 'success', 3: 'warning', 4: 'info' }[type] || 'info';
    },
  },
  filters: {
    formatTime(val) {
      if (!val) return '-';
      return new Date(val * 1000).toLocaleString('zh-CN', { hour12: false });
    }
  }
};
</script>

<style lang="less" scoped>
#protocolRecord {
  padding: 16px;

  .search-bar {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0;
  }

  .pagination-wrap {
    margin-top: 16px;
    text-align: right;
  }
}
</style>
